export const styles = {
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative',
  },
  head: {
    transition: 'all 0.3s ease',
    top: '0px',
    position: 'relative',
  },
  iconButton: {
    right: 'calc(310px + 60px)',
    position: 'fixed',
    zIndex: 99,
    '@media (max-width: 1200px)': {
      right: '26px',
    },
  },
  button: {
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 100,
  },
};
